export function getViewport(map) {
  const { lng, lat } = map.getCenter();
  const zoom = map.getZoom();
  const pitch = map.getPitch();
  const bearing = map.getBearing();
  return {
    latitude: lat,
    longitude: lng,
    zoom,
    bearing,
    pitch,
  };
}
